import Vue from "vue";
import Vuex from "vuex";

import schoolsModule from "./modules/schools";
import essentialsModule from "./modules/essentials";
import newsModule from "./modules/news";
import eventsModule from "./modules/events";
import newslettersModule from "./modules/newsletters";
import userModule from "./modules/user";
import notifications from "./modules/notifications";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);
export default new Vuex.Store({
  modules: {
    schoolsModule,
    essentialsModule,
    newsModule,
    eventsModule,
    newslettersModule,
    userModule,
    notifications,
  },
  plugins: [createPersistedState()],
  state: {
    isLoading: false,
  },
  getters: {
    isLoading: (state) => state.isLoading,
  },
  mutations: {
    SET_IS_LOADING: function(state, isLoading) {
      state.isLoading = isLoading;
    },
  },
  actions: {},
});
